import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/index
const home = () => import('@/views/home');
const dealerbind = () => import('@/views/dealerbind');
const customerbind = () => import('@/views/iot/customerbind');
const error = () => import('@/views/error');
const dealerinfo = () => import('@/views/dealerinfo');
const shopinfo = () => import('@/views/shop/shopinfo');
const iothome = () => import('@/views/iot/iothome');
const iotdetail = () => import('@/views/iot/iotdetail');
const suser = () => import('@/views/shop/suser');
const saddress = () => import('@/views/shop/saddress');
const saddressadd = () => import('@/views/shop/saddressadd');
const sconfirm = () => import('@/views/shop/sconfirm');
const sdetail = () => import('@/views/shop/sdetail');
const sintegral = () => import('@/views/shop/sintegral');
const sorder = () => import('@/views/shop/sorder');
const customerList = () => import('@/views/customer/customerList');
const useLogin = () => import('@/views/customer/userLogin');
const userInfo = () => import('@/views/customer/userInfo');
const appointment = () => import('@/views/customer/appointment');
const apply = () => import('@/views/customer/apply');
const agencyInfo = () => import('@/views/supervise/agencyInfo');
const superviseInfo = () => import('@/views/supervise/superviseInfo');
const login = () => import('@/views/supervise/login');
const superviseLogin = () => import('@/views/supervise/superviseLogin');
const agencyLogin = () => import('@/views/supervise/agencyLogin');
const agencyhome = () => import('@/views/supervise/agencyhome');
const supervisehome = () => import('@/views/supervise/supervisehome');
const supervisejudeg = () => import('@/views/supervise/supervisejudeg');
const superviseuserInfo = () => import('@/views/supervise/superviseuserInfo');
const supervisedetail = () => import('@/views/supervise/supervisedetail');
const agencydetail = () => import('@/views/supervise/agencydetail');
const agencyuserInfo = () => import('@/views/supervise/agencyuserInfo');

import appRoutes from "./app";

Vue.use(Router)

export default new Router({
  mode:"hash",
  //mode:"history",
  base: process.env==='production'?'/zknjmui/':"",
  routes: [
    {
      path: '/',
      redirect:'/login-app'
    },
    {
      path: '/home',
      name: 'home',
      meta:{
        index:10,
        iscatch:true
      },
      component: home
    },
    {
      path: '/error',
      name: 'error',
      component: error
    },
    {
      path: '/dealerbind',
      name: 'dealerbind',
      component: dealerbind
    },
    {
      path: '/dealerinfo',
      name: 'dealerinfo',
      component: dealerinfo
    },
    // 用户登录
    {
      path: '/useLogin',
      name: 'useLogin',
      component: useLogin,
      meta:{
        type:'user'
      }
    },
    // 用户工单列表
    {
      path: '/usercustomerList',
      // name: 'customerList',
      component: customerList,
      meta:{
        type:'user'
      }
    },
    {
      path: '/userInfo',
      component: userInfo
    },
    // 用户预约
    {
      path: '/userappointment',
      name: 'userappointment',
      component: appointment,
      meta:{
        type:'user',
        index:15,
        iscatch:true,
      }
    },
    {
      path: '/userapply',
      component: apply
    },
    {
      path: '/agencyInfo',
      component: agencyInfo,
      meta:{
        type:'agency'
      }
    },
    {
      path: '/superviseInfo',
      component: superviseInfo,
      meta:{
        type:'supervise'
      }
    },
    // 监管登录
    {
      path: '/superviseLogin',
      component: superviseLogin,
    },
    {
      path: '/agencyLogin',
      component: agencyLogin
    },
    // 选择系统登录
    {
      path: '/login',
      component: login
    },
    // 中介首页
    {
      path: '/agencyhome',
      component: agencyhome,
      meta:{
        type:'agency'
      }
    },
    // 监管首页
    {
      path: '/supervisehome',
      component: supervisehome,
      meta:{
        type:'supervise'
      }
    },
    // 监管评价
    {
      path: '/supervisejudeg',
      component: supervisejudeg,
      meta:{
        type:'supervise'
      }
    },
    // {
    //   path: '/superviseuserInfo',
    //   component: superviseuserInfo,
    //   meta:{
    //     type:'supervise'
    //   }
    // },
    // {
    //   path: '/agencyuserInfo',
    //   component: agencyuserInfo,
    //   meta:{
    //     type:'agency'
    //   }
    // },
    // 监管详情
    {
      path: '/supervisedetail',
      name:'supervisedetail',
      component: supervisedetail,
      meta:{
        type:'supervise'
      }
    },
    // 中介详情
    {
      path: '/agencydetail',
      name:'agencydetail',
      component: agencydetail,
      meta:{
        type:'agency'
      }
    },
    //设置
    {
      path: '/settings',
      name: 'settings',
      meta:{
        type:'any'
      },
			component: () => import('@/views/settings/index'),
    },
    //我的二维码
    {
      path: '/code',
      name: 'code',
      meta:{
        type:'any'
      },
			component: () => import('@/views/settings/code'),
    },
    //支付成功
    {
      path: '/paySuccess',
      name: 'paySuccess',
      meta:{
        type:'any'
      },
			component: () => import('@/views/pay/paySuccess'),
    },
        //支付回调成功
    {
          path: '/wxpayreturnurl',
          name: 'index',
          meta:{
            type:'any'
          },
          component: () => import('@/views/wxpayreturn/index'),
    },
    //积分商城
    {
      path: '/shopinfo',
      name: 'shopinfo',
      component: shopinfo
    },
    {
      path: '/suser',
      name: 'suser',
      component: suser
    },
    {
      path: '/saddress',
      name: 'saddress',
      component: saddress
    },
    {
      path: '/saddressadd',
      name: 'saddressadd',
      component: saddressadd
    },
    {
      path: '/sconfirm',
      name: 'sconfirm',
      component: sconfirm
    },
    {
      path: '/sdetail',
      name: 'sdetail',
      component: sdetail
    },
    {
      path: '/sintegral',
      name: 'sintegral',
      component: sintegral
    },
    {
      path: '/sorder',
      name: 'sorder',
      component: sorder
    },
    //物联网
    {
      path: '/iothome',
      name: 'iothome',
      component: iothome,
      meta:{
        index:'0'
      }
    },
    {
      path: '/customerbind',
      name: 'customerbind',
      component: customerbind,
      meta:{
        index:'0'
      }
    },
    //物联网详情
    {
      path: '/iotdetail',
      component: iotdetail,
      meta:{
        index:'1',
        type:'iotdetail'
      }
    },
    ...appRoutes,
  ]
})

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}





// WEBPACK FOOTER //
// ./src/router/index.js